<template>
  <div style="width: 100%; height: 100%">
    <div class="leftPie2" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
// const echarts = require('echarts/lib/echarts')
// require('echarts/lib/component/tooltip')
// require('echarts/lib/component/legend')
// require('echarts/lib/chart/pie')
import * as echarts from 'echarts'
// var charts = {}
export default {
  data () {
    return {
      chart: {}
    }
  },
  created () {},
  mounted () {
    this.init()
    // 根据浏览器宽度变化改变可视化报表图宽高
    window.addEventListener('resize', () => {
      this.chart.resize()
    })
  },
  methods: {
    init () {
      this.chart = echarts.init(document.querySelector('.leftPie2'))
      this.chart.setOption({
        title: {
          text: '销售',
          left: '6%',
          top: '20px',
          textStyle: {
            color: '#06f1ef',
            fontSize: '20px'
          }
        },
        legend: {
          orient: 'vertical',
          right: '10%',
          bottom: '20%',
          textStyle: {
            color: 'white',
            fontSize: '14px'
          }
        },
        series: [
          {
            name: '库存分析',
            type: 'pie',
            radius: ['30%', '75%'],
            avoidLabelOverlap: false,
            center: ['45%', '55%'],

            label: {
              show: true,
              position: 'inside',
              // formatter: '{c}\n{d}%',
              formatter: '{c}',
              align: 'center',
              color: '#06f1ef',
              fontWeight: 'bold',
              fontSize: '12px'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '20',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            // itemStyle: {
            //   borderColor: '#ffffff',
            //   borderWidth: 1
            // },
            data: [
              { value: 752, name: '成品油' },
              { value: 735, name: '碳材料' },
              { value: 369, name: '化工品' },
              { value: 455, name: '聚烯烃' },
              { value: 168, name: '沥青' }
            ]
          }
        ]
      })

      this.chart.on('click', (params) => {
        if (params.name === '利丰达库区') {
          this.$router.push({ path: '/storeArea/lfd' })
        }
        if (params.name === '丰利库区') {
          this.$router.push({ path: '/storeArea/flk' })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
